import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';
import { QuestionIcon } from './bs-icons';
import { cn } from '../lib/utils';
import { BaseButton } from './base-button';

export interface ConfirmDialogProps {
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  title: string;
  description?: string;
  /** Text for the left link button */
  linkText?: string;
  /** Callback when link button is clicked */
  onLinkClick?: () => void;
  /** Text for the cancel button */
  cancelText?: string;
  /** Callback when cancel button is clicked */
  onCancel?: () => void;
  /** Text for the confirm button */
  confirmText?: string;
  /** Callback when confirm button is clicked */
  onConfirm?: () => void;
  /** Whether to show the link button */
  showLink?: boolean;
  /** Whether to show the cancel button */
  showCancel?: boolean;
  /** Container element for the dialog portal */
  container?: HTMLElement;
}

export function ConfirmDialog({
  open,
  onOpenChange,
  title,
  description,
  linkText = '留在此页',
  onLinkClick,
  cancelText = '不保存',
  onCancel,
  confirmText = '保存并继续',
  onConfirm,
  container,
  showLink = true,
  showCancel = true,
}: ConfirmDialogProps) {
  const btnStyle = {
    borderRadius: 4,
    padding: '6px 20px',
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        container={container}
        className={cn(
          'w-[480px] max-w-[480px] p-0 gap-0 rounded-[10px] border-none',
          'shadow-[0px_0px_10px_0px_rgba(0,0,0,0.04)]',
          '[&>button]:hidden'
        )}
      >
        <DialogHeader className="flex flex-row items-start gap-[10px] p-9 pb-0">
          <div className="size-[30px] shrink-0 text-[#0265FF]">
            <QuestionIcon />
          </div>
          <div className="flex flex-col gap-2">
            <DialogTitle className="text-[16px] font-[700] text-[#030303] leading-normal">
              {title}
            </DialogTitle>
            {description && (
              <DialogDescription className="text-[14px] text-[#666] leading-normal">
                {description}
              </DialogDescription>
            )}
          </div>
        </DialogHeader>

        <DialogFooter className="flex flex-row items-center !justify-between p-9 pt-6">
          {showLink ? (
            <button
              type="button"
              className="text-[14px] text-[#0265ff] hover:text-[#0265ff]/80 bg-transparent border-none cursor-pointer"
              onClick={onLinkClick || (() => {
                console.log('Link clicked');

                onOpenChange?.(false);
              })}
            >
              {linkText}
            </button>
          ) : (
            <div />
          )}

          <div className="flex items-center gap-3">
            {showCancel && (
              <BaseButton
                className="hover:text-[#121111]"
                onClick={onCancel}
              >
                {cancelText}
              </BaseButton>
              // <button
              //   type="button"
              //   onClick={onCancel}
              //   style={btnStyle}
              //   className={cn(
              //     'h-8 px-5 py-1.5 rounded border border-[#e0e0e0]',
              //     'text-[14px] text-[#030303] bg-white',
              //     'hover:bg-gray-50 cursor-pointer'
              //   )}
              // >
              //   {cancelText}
              // </button>
            )}
            <button
              type="button"
              onClick={onConfirm}
              style={btnStyle}
              className={cn(
                // 'h-8 px-5 py-1.5 rounded',
                'text-[14px] text-white bg-[#0265ff]',
                'hover:bg-[#0265ff]/80 cursor-pointer border-none'
              )}
            >
              {confirmText}
            </button>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
